import { createStore } from 'vuex'

export default createStore({
  state: {
    site_name: '',
    site_description: '',
    disabled_scroll: false,
    is_loading: false,
    show_menu: false,
    hide_menu: false,
    cookies: '',
  },
  getters: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
  }
})
